import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useI18n } from "@/i18n";
import EscudoNacional from "@/components/EscudoNacional";
import LangSwitcher from "@/components/layout/LangSwitcher";

export default function Header() {
  const { lang, t } = useI18n();
  const [open, setOpen] = useState(false);

  const base = `/${lang}`;
  const navLinks = [
    { to: `${base}#programs`, label: t("nav.programs"), id: "nav-programs" },
    { to: `${base}#resources`, label: t("nav.resources"), id: "nav-resources" },
    { to: `${base}#contact`, label: t("nav.contact"), id: "nav-contact" },
  ];

  const close = () => setOpen(false);

  return (
    <header className="kv-header" data-testid="site-header">
      <div className="kv-flag-strip" aria-hidden="true" />
      <div className="kv-container kv-header-inner">
        <Link
          to={base}
          className="flex items-center gap-3"
          data-testid="header-brand-link"
          onClick={close}
        >
          <EscudoNacional size={40} title={t("footer.escudoLabel")} />
          <div>
            <div className="font-display text-white" style={{ fontSize: "1.35rem", fontWeight: 700, letterSpacing: "0.01em", lineHeight: 1 }}>
              {t("brand.name")}
            </div>
            <div style={{ fontSize: "0.72rem", color: "#a9c4e6", marginTop: 2 }}>
              {t("brand.tagline")}
            </div>
          </div>
        </Link>

        <nav className="kv-nav" aria-label="Primary">
          <NavLink to={base} end data-testid="nav-home">
            {t("nav.home")}
          </NavLink>
          {navLinks.map((l) => (
            <a href={l.to} key={l.id} data-testid={l.id}>
              {l.label}
            </a>
          ))}
          <NavLink to={`${base}/privacy`} data-testid="nav-privacy">
            {t("nav.privacy")}
          </NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <LangSwitcher currentLang={lang} />
          <button
            type="button"
            className="kv-mobile-btn"
            aria-label={open ? t("nav.close") : t("nav.menu")}
            data-testid="mobile-menu-button"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="kv-drawer" data-testid="mobile-drawer">
          <div className="flex items-center justify-between mb-6">
            <Link to={base} className="flex items-center gap-3" onClick={close}>
              <EscudoNacional size={36} title={t("footer.escudoLabel")} />
              <span className="font-display" style={{ color: "#fff", fontSize: "1.2rem", fontWeight: 700 }}>
                {t("brand.name")}
              </span>
            </Link>
            <button
              type="button"
              className="kv-mobile-btn"
              aria-label={t("nav.close")}
              onClick={close}
              data-testid="mobile-menu-close"
            >
              <X size={22} />
            </button>
          </div>
          <nav>
            <Link to={base} onClick={close} data-testid="drawer-home">
              {t("nav.home")}
            </Link>
            {navLinks.map((l) => (
              <a
                href={l.to}
                key={l.id}
                onClick={close}
                data-testid={`drawer-${l.id}`}
              >
                {l.label}
              </a>
            ))}
            <Link to={`${base}/privacy`} onClick={close} data-testid="drawer-privacy">
              {t("nav.privacy")}
            </Link>
            <Link to={`${base}/cookies`} onClick={close} data-testid="drawer-cookies">
              {t("nav.cookies")}
            </Link>
            <Link to={`${base}/terms`} onClick={close} data-testid="drawer-terms">
              {t("nav.terms")}
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
